/**
 * Constants for benchmarking features
 */

// Default maximum value for capital raised when the actual max is null
// Used to ensure proper range formatting in saved jobs and navigation
export const MAX_CAPITAL_RAISED_FALLBACK = 999000000;
